import { pieceKind } from "./types";

export default function Piece({kind, black}: {kind: pieceKind, black: boolean}) {
    return (
        <img
            src={require('./assets/'+kind+'-'+(black?'b':'w')+'.png')}
            style={{height: '4em', width: '4em'}}
        />
    )
}

// import { pieceKind } from "./types";

// export default function Piece ({kind, black}: {kind: pieceKind, black: boolean}) {
//     return (
//         <div style={{position: 'relative', overflow: 'hidden', height: '4em', width: '4em'}}>
//         <img style={{position: 'absolute', width: '24em', top: black?'-4em':'0', left: {ra: 0, ma: -4, aa: -8, ku: -12, th: -16, ka: -20}[kind]+'em'}} src={require('./assets/chess-sprite.png')} />
//         </div>
//     )
// }